import type { SVGProps } from 'react';

interface SVGRProps {
  readonly title?: string;
  readonly titleId?: string;
}

const SvgIconOutlineHuman = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={47}
    height={47}
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill="#32353B" d="M23.32 17.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
    <path
      fill="#32353B"
      d="M27.21 19.61c-.39-.39-1.06-1.11-2.36-1.11h-2.54c-2.75-.01-4.99-2.25-4.99-5h-2c0 3.16 2.11 5.84 5 6.71V33.5h2v-6h2v6h2V21.55l3.95 3.95 1.41-1.41z"
    />
    <rect
      width={46.333}
      height={46.333}
      x={0.333}
      y={0.333}
      stroke="#32353B"
      strokeOpacity={0.2}
      strokeWidth={0.667}
      rx={11.667}
    />
  </svg>
);

export default SvgIconOutlineHuman;
